// Cor de destaque das páginas públicas (landing e podcast). Estava declarada
// dentro do index.js da landing; virou módulo próprio quando a segunda página
// passou a precisar dela — duas cópias divergiriam na primeira troca de marca.
export const ACCENT = "#4ADF83";

// Fundo e tipografia comuns às páginas públicas. Mesma razão: as duas páginas
// precisam ser indistinguíveis, e repetir o objeto abriria espaço para uma
// delas ficar para trás.
export const PAGINA_PUBLICA_STYLE = {
  background: "#0a0a0a",
  minHeight: "100vh",
  color: "#fff",
  fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
  overflowX: "hidden",
};

// O nav é `position: fixed`, então o primeiro bloco de cada página precisa
// descer. A landing já usava este valor no HERO; a página de podcast usa o
// mesmo para começar na mesma altura.
export const TOPO_ABAIXO_DO_NAV = "clamp(120px, 22vh, 200px)";
